// src/admin/pages/OrdersPage.jsx
import React, { useEffect, useState } from "react";
import { adminGetAllOrders } from "../api/admin";
import OrdersTable from "../components/OrdersTable";
import OrderDetailsModal from "../components/OrderDetailsModal";

const OrdersPage = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const res = await adminGetAllOrders();
      setOrders(res.data || []);
    } catch (err) {
      console.error("Failed to load orders", err);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Filtering Logic
  const filteredOrders = orders.filter((order) => {
    const customerName = (order.user?.name || "").toLowerCase();
    const shippingName = (order.shippingAddress?.fullName || order.shippingAddress?.name || "").toLowerCase();
    const customerEmail = (order.user?.email || order.shippingAddress?.email || "").toLowerCase();
    const orderId = (order._id || order.id || "").toLowerCase();
    const search = searchTerm.toLowerCase();

    const matchesSearch =
      customerName.includes(search) ||
      shippingName.includes(search) ||
      customerEmail.includes(search) ||
      orderId.includes(search);

    const matchesStatus =
      statusFilter === "all" ||
      (order.status || "").toLowerCase() === statusFilter.toLowerCase();

    return matchesSearch && matchesStatus;
  });

  const [selectedOrder, setSelectedOrder] = useState(null);

  const handleViewOrder = (order) => {
    setSelectedOrder(order);
  };

  const closeDetails = () => {
    setSelectedOrder(null);
  };

  return (
    <div className="admin-page">
      {!selectedOrder ? (
        <>
          <div className="page-header orders-page-header" style={{ marginBottom: '25px' }}>
            <h2 className="adminproducts">Orders List</h2>
            <div className="header-actions orders-filters-container">
              <div className="search-container order-id-search">
                <span className="search-label">Search:</span>
                <input
                  type="text"
                  placeholder="Name, Email or Order ID..."
                  className="user-search-input"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              <div className="search-container order-status-filter">
                <span className="search-label">Status:</span>
                <select
                  className="user-search-input"
                  style={{ border: 'none', background: 'transparent', cursor: 'pointer', outline: 'none' }}
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <option value="all">All Status</option>
                  <option value="ORDER PLACED">ORDER PLACED</option>
                  <option value="CONFIRMED">CONFIRMED</option>
                  <option value="DISPATCHED">DISPATCHED</option>
                  <option value="DELIVERED">DELIVERED</option>
                  <option value="CANCELED">CANCELED</option>
                </select>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="loading-container">Loading orders...</div>
          ) : filteredOrders.length > 0 ? (
            <OrdersTable 
              orders={filteredOrders} 
              onViewOrder={handleViewOrder}
              refreshOrders={fetchOrders} 
            />
          ) : (
            <div className="no-orders-message" style={{
              background: 'white',
              padding: '60px',
              borderRadius: '16px',
              textAlign: 'center',
              boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
              marginTop: '25px'
            }}>
              <div style={{ fontSize: '3rem', marginBottom: '15px' }}>📋</div>
              <h3 style={{ color: '#181c32', marginBottom: '8px' }}>No Orders Found</h3>
              <p style={{ color: '#a1a5b7' }}>
                {searchTerm || statusFilter !== 'all'
                  ? "No orders match your current filters. Try adjusting your search."
                  : "You haven't received any orders yet."}
              </p>
              {(searchTerm || statusFilter !== 'all') && (
                <button
                  onClick={() => { setSearchTerm(""); setStatusFilter("all"); }}
                  style={{
                    marginTop: '20px',
                    padding: '10px 20px',
                    background: '#f5f8fa',
                    border: 'none',
                    borderRadius: '8px',
                    color: '#3699ff',
                    fontWeight: '600',
                    cursor: 'pointer'
                  }}
                >
                  Clear All Filters
                </button>
              )}
            </div>
          )}
        </>
      ) : (
        <>
          <div className="page-header">
            <div className="header-with-back">
              <button className="back-btn" onClick={closeDetails}>← Back</button>
              <h2 className="adminproducts">Order Details</h2>
            </div>
          </div>
          <div className="form-inline-container" style={{ padding: '0' }}>
            <OrderDetailsModal
              order={selectedOrder}
              onClose={closeDetails}
              refreshOrders={fetchOrders}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default OrdersPage;

